import { Routes } from 'core/routes.types';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getOrderRecap, resetOrder } from 'redux/order';
import { OrderRecap } from 'services/order/order.type';

type CartVMReturnType =
    | {
          isEmpty: true;
          order: undefined;
          navigateToPayment: () => void;
          navigateToHome: () => void;
          flushCart: () => void;
      }
    | {
          isEmpty: false;
          order: OrderRecap;
          navigateToPayment: () => void;
          navigateToHome: () => void;
          flushCart: () => void;
      };

export const useCartVM = (): CartVMReturnType => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const navigateToHome = useCallback(() => navigate(Routes.MenuHome), [navigate]);
    const navigateToPayment = useCallback(() => navigate(Routes.Payment), [navigate]);
    const flushCart = useCallback(() => dispatch(resetOrder(undefined)), [dispatch]);

    const order = useSelector(getOrderRecap);
    const commonFn = {
        navigateToPayment,
        navigateToHome,
        flushCart,
    };

    return order
        ? { isEmpty: false, order, ...commonFn }
        : { isEmpty: true, order: undefined, ...commonFn };
};
